var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"sidebar-minimizer",attrs:{"variant":"facebook icon","type":"button"},on:{"click":function($event){return _vm.onClick()}}})
}
var staticRenderFns = []

export { render, staticRenderFns }